import { useEffect, useState } from "react";
import { useIsClient } from "usehooks-ts";
import { isInPreviewEditor } from "../utils/storyblok/is-in-preview-editor";

export const useIsInPreviewEditor = (): boolean => {
	const isClient = useIsClient();
	const [isInPreviewEditorState, setIsInPreviewEditorState] = useState(false);

	useEffect(() => {
		if (isClient) {
			setIsInPreviewEditorState(isInPreviewEditor());
		}
	}, [isClient]);

	return isInPreviewEditorState;
};
